exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".padding-4percent[data-v-e7897b7c]{width:200px}.btn[data-v-e7897b7c]{margin-left:4%}.button-padding[data-v-e7897b7c]{margin-top:6%}", ""]);

// exports
